<template>
  <Teleport to="body">
    <div class="toast-stack" aria-live="polite" aria-atomic="false">
      <TransitionGroup name="toast">
        <article
          v-for="item in toasts"
          :key="item.id"
          class="app-toast"
          :class="item.type"
        >
          <i :class="icon(item.type)"></i>
          <span>{{ item.message }}</span>
          <button type="button" title="Fermer" @click="removeToast(item.id)">
            <i class="bi bi-x-lg"></i>
          </button>
        </article>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { removeToast, ToastType, toasts } from "@/Shared/services/toastService";

function icon(type: ToastType) {
  return {
    success: "bi bi-check-circle",
    danger: "bi bi-exclamation-triangle",
    warning: "bi bi-hourglass-split",
  }[type];
}
</script>
